import type { PwaView, SubjectPack } from "../ai_literacy/subjectPack.js";
import { buildEpsoAd8AiGraph, EPSO_AD8_AI_NODE_IDS } from "./curriculum.js";
import {
  COPY,
  DEFAULT_LOCALE,
  SUPPORTED_LOCALES,
  getCopy,
  type Locale,
  type LocaleStrings,
  type StemTemplate,
} from "./conceptCopy.js";
import { EPSO_AD8_AI_SEED_QUESTIONS } from "./seed.js";
import { EPSO_AD8_AI_BACKPACK_DECK } from "./decks/backpack.js";
import { EPSO_AD8_AI_SPOTLIE_DECK } from "./decks/spotlie.js";
import { EPSO_AD8_AI_REDACT_DECK } from "./decks/redact.js";

function recommendViewForEpsoAd8Ai(conceptId: string | null): PwaView | null {
  if (!conceptId) return null;
  if (["act_prohibited", "act_high_risk", "ai_office_enforcement"].includes(conceptId)) {
    return "spotlie";
  }
  if (["act_obligations_ops", "act_scope_roles", "gpai_transparency"].includes(conceptId)) {
    return "backpack";
  }
  if (conceptId === "trustworthiness_eval") return "redact";
  return "mcq";
}

/** Practice pack for EPSO/AD/430/26 Field 1. Not official EPSO material. */
export const EPSO_AD8_AI_PACK: SubjectPack = {
  id: "epso_ad8_ai",
  buildGraph: buildEpsoAd8AiGraph,
  conceptIds: EPSO_AD8_AI_NODE_IDS,
  copy: COPY,
  getCopy,
  defaultLocale: DEFAULT_LOCALE,
  supportedLocales: SUPPORTED_LOCALES,
  seedQuestions: EPSO_AD8_AI_SEED_QUESTIONS,
  recommendViewForConcept: recommendViewForEpsoAd8Ai,
  quest: {
    id: "ranking_test",
    steps: [
      { conceptId: "act_scope_roles", minElo: 1300 },
      { conceptId: "act_high_risk", minElo: 1320 },
      { conceptId: "act_obligations_ops", minElo: 1320 },
      { conceptId: "gpai_transparency", minElo: 1320 },
      { conceptId: "ai_office_enforcement", minElo: 1300 },
    ],
  },
  decks: {
    backpack: EPSO_AD8_AI_BACKPACK_DECK,
    spotlie: EPSO_AD8_AI_SPOTLIE_DECK,
    redact: EPSO_AD8_AI_REDACT_DECK,
  },
};

export type { Locale, LocaleStrings, StemTemplate };
